import OrganizationsSelectList from '@/app/components/features/membership/changeOrg/OrganizationsSelectList';
import { Button } from '@/app/ui/components/button';
import { Card } from '@/app/ui/components/card';
import { Logo } from '@/app/ui/components/logo';
import { useAuth } from '@/app/utils/auth';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslations } from 'use-intl';

export const Route = createFileRoute('/_authed/(membership)/choose-organization')({
  component: RouteComponent,
});

function RouteComponent() {
  const { logout } = useAuth();
  const t = useTranslations();

  return (
    <div className="px-5 -translate-y-5 w-full my-auto">
      <Logo className="mb-5 mx-auto" />
      <Card className="max-w-92 lg:p-6 p-5 mx-auto w-full">
        <p className="text-lg text-center font-semibold mb-6">{t('pages.chooseOrg.header')}</p>
        <OrganizationsSelectList />
        <Button variant="ghost" onClick={() => logout()} className="w-full mt-4" size="lg">
          {t('components.headernav.logout')}
        </Button>
      </Card>
    </div>
  );
}
